import { render, staticRenderFns } from "./min-starting-diagnostic.vue?vue&type=template&id=ad3cbc42&scoped=true&"
import script from "./min-starting-diagnostic.ts?vue&type=script&lang=ts&"
export * from "./min-starting-diagnostic.ts?vue&type=script&lang=ts&"
import style0 from "./min-starting-diagnostic.scss?vue&type=style&index=0&id=ad3cbc42&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3cbc42",
  null
  
)

export default component.exports